/**
 * @module /admin/widgets/edit/store
 *
 * Vuex module for /admin/widgets/edit
 */
export * from './state';
export * from './actions';
export * from './getters';
export * from './mutations';

export const namespaced = true;
